const Loading = () => {
    return (<div className={"alert alert-warning"}>در حال دریافت اطلاعات...</div>);
}

export default Loading;